module.exports = __webpack_public_path__ + "img/wef_orion_0.70fa08b4.png";